import React, { memo } from "react";
import { StyledImage } from "../ProductDetail.styles";
import { ButtonBase } from "@mui/material";
import styled, {  useTheme } from "styled-components";
import Box from "component/layoutComponents/Box";
import DefaultUptimeTheme from "component/theme/defaultTheme";

type ImageItem = { small: string; medium: string; large: string };

const ImageWrapper = styled(ButtonBase)<{
  theme: typeof DefaultUptimeTheme;
  selected: boolean;
}>(
  ({
    theme,
    selected,
  }) => ({
    display: "inherit !important",
    borderRadius: "4px !important",
    border: selected
      ? `1px solid ${theme.uptimeColors.mainTheme.primary} !important`
      : `1px solid ${theme.uptimeColors.grayScales.grayish} !important`,
  })
);

const ImagesContent = ({
  images,
  currentImage,
  onClick,
}: {
  images: ImageItem[];
  currentImage: string;
  onClick: (image: string) => void;
}) => {
  const theme = useTheme() as unknown as typeof DefaultUptimeTheme;

  return (
    <>
      <StyledImage src={currentImage} alt="product image" />
      <Box
        mt={`${theme.uptimeSpace[10]}px`}
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
      >
        {images?.map((image: ImageItem, index: React.Key) => {
          return (
            <ImageWrapper
              key={image.small + index}
              onClick={() => onClick(image.large)}
              selected={currentImage === image.medium}
            >
              <Box width={74} height={74}>
                <StyledImage src={image.small} alt="product image" />
              </Box>
            </ImageWrapper>
          );
        })}
      </Box>
    </>
  );
};

export default memo(ImagesContent);
